import IUserState from "./IUserState";
import {Alert} from "react-native";

const UserReducers =  {
    SAVE_USER:saveUser
}

function saveUser(state:IUserState, action:any) {
    return { ...state, ...{current:action.user} };

}

export default UserReducers
